import { WindowCommunicationBridgeService } from "../../../ShellCommon/eventModule/window-communication-bridge";
import { ContextService } from "../context/context-service";
import { DialogService } from "../dialog";
import { AuthenticationLoggerService } from "./authentication-logger";
import { MsalAuthenticationServiceImplementation } from "../msal/msal-authentication-service";

const logoutCloseAllOtherWindowsEventName = "logoutCloseAllOtherWindowsEvent";

export class LogoutService {
  // @ngInject
  constructor(
    private windowCommunicationBridgeService: WindowCommunicationBridgeService,
    private contextService: ContextService,
    private authenticationLogger: AuthenticationLoggerService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private dialogService: DialogService
  ) {}

  /**
   * Attempts to logout, if there are conditions that could warrant preventing the logout, the user will be prompted to proceed or not
   */
  public attemptLogout() {
    this.contextService.activeContexts().then((contexts: any) => {
      if (contexts.length > 1) {
        this.dialogService.showContent(`<logout-dialog></logout-dialog>`, undefined, undefined, true);
      } else {
        this.performLogout();
      }
    });
  }

  /**
   * Performs a logout, and will attempt to close out all other windows
   */
  public performLogout() {
    let logout = () => {
      this.authenticationLogger.recordLogoutStarted();
      this.msalAuthenticationService.logout();
    };
    this.windowCommunicationBridgeService
      .publish(logoutCloseAllOtherWindowsEventName, this.contextService.current.id)
      .then(logout)
      .catch(logout);
  }

  /**
   * Registers with WCB to listen for the logout window close event
   */
  // @ngInject
  public static subscribeLogoutCloseAllOtherWindowsEvent = (
    windowCommunicationBridgeService: WindowCommunicationBridgeService,
    contextService: ContextService,
    $window: ng.IWindowService
  ) => {
    windowCommunicationBridgeService.subscribe(
      logoutCloseAllOtherWindowsEventName,
      (currentContextId: string) => {
        if (contextService.current.id !== currentContextId) {
          $window.close();
        }
      },
      undefined
    );
  };
}
